export enum MaskTypeEnum {
  JUST_NUMBER = 'JUST_NUMBER',
  HOUR_MINUTE = 'HOUR_MINUTE',
}
